#import "./PolicyDetailFields.graphql"

mutation RecordPolicyReview($input: RecordPolicyReviewInput!) {
  recordPolicyReview(input: $input) {
    policy {
      ...PolicyDetailFields
    }
  }
}
